import { takeLatest, fork, put, call } from 'redux-saga/effects';
import { showSpinner, hideSpinner } from '../global/actions';
import { sortBillingPeriodsByLatest } from '../../utils/helpers';
import * as billingActions from './actions';
import { ApiRequest } from '../../utils/api';
import { doCallApi } from '../global/sagas';
import { BILLING_PERIODS_FETCH, INVOICES_FETCH, INVOICES_INITIALIZE, SET_DEFAULT_PAYMENT_METHOD, FETCH_ZUORA_SIGNATURE } from './constants';

export function* fetchBillingPeriods(accountId) {
	const { response } = yield call(doCallApi, true, ApiRequest.getBillingPeriods, accountId);

	if (response) {
		yield put(billingActions.receiveBillingPeriods(response));
	}
}

function* doFetchBillingPeriods(action) {
	const { id } = action.payload;
	yield put(showSpinner());
	yield fetchBillingPeriods(id);
	yield put(hideSpinner());
}

function* fetchInvoices(action) {
	//eslint-disable-line
	yield put(showSpinner());
	try {
		const { response } = yield call(doCallApi, true, ApiRequest.getInvoices, action.payload.id, action.payload.fromBillingPeriodId, action.payload.amount);

		if (response) {
			yield put(billingActions.receiveInvoices(response));
		}
	} catch (e) {
		// error catching?
	}
	yield put(hideSpinner());
}

function* initializeInvoices(action) {
	yield put(showSpinner());
	const { response } = yield call(doCallApi, true, ApiRequest.getBillingPeriods, action.payload.accountId);
	if (response) {
		yield put(billingActions.receiveBillingPeriods(response));
		const sortedPeriods = sortBillingPeriodsByLatest(response);
		let returned;
		if (sortedPeriods.length === 1) {
			returned = yield call(doCallApi, true, ApiRequest.getInvoices, action.payload.id, sortedPeriods[0].id, 1);
		} else if (sortedPeriods.length > 1) {
			returned = yield call(doCallApi, true, ApiRequest.getInvoices, action.payload.id, sortedPeriods[0].id, 2);
		}
		if (returned.response) {
			yield put(billingActions.receiveInvoices(returned.response));
		}
	}
	yield put(hideSpinner());
}

function* doFetchZuoraSignature(action) {
	const { pageId, zuoraUrl } = action.payload;
	yield put(showSpinner());
	const { response } = yield call(doCallApi, true, ApiRequest.getZuoraSignature, pageId, zuoraUrl);
	if (response) {
		const signatureObject = {
			...response
		};
		yield put(billingActions.receiveZuoraSignature(signatureObject));
	}
	yield put(hideSpinner());
}

function* doSetDefaultPaymentMethod(action) {
	yield put(showSpinner());
	const { response } = yield call(doCallApi, true, ApiRequest.setDefaultPaymentMethod, action.payload.accountId, action.payload.paymentMethodId);
	if (response) {
		yield put(billingActions.setDefaultPaymentMethodFinished(response));
	}
	yield put(hideSpinner());
}

export function* root() {
	yield fork(takeLatest, BILLING_PERIODS_FETCH, doFetchBillingPeriods);
	yield fork(takeLatest, INVOICES_FETCH, fetchInvoices);
	yield fork(takeLatest, INVOICES_INITIALIZE, initializeInvoices);
	yield fork(takeLatest, FETCH_ZUORA_SIGNATURE, doFetchZuoraSignature);
	yield fork(takeLatest, SET_DEFAULT_PAYMENT_METHOD, doSetDefaultPaymentMethod);
}

// Bootstrap sagas
export default [root];
